module.exports = __webpack_public_path__ + "img/tron (37).76073922.jpg";